import { baseApi } from "./index";

export interface FieldAvailabilityParams {
  resource: string;
  field: string;
  value: string;
  exclude_id?: number;
}

export interface FieldAvailabilityResponse {
  resource: string;
  field: string;
  value: string;
  available: boolean;
  code?: string;
  context?: Record<string, unknown>;
}

export const fieldValidationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    checkFieldAvailability: builder.query<FieldAvailabilityResponse, FieldAvailabilityParams>({
      query: ({ resource, field, value, exclude_id }) => ({
        url: "/api/validation/field-availability/",
        method: "GET",
        params: { resource, field, value, exclude_id },
        credentials: "include" as const,
      }),
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useCheckFieldAvailabilityQuery } = fieldValidationApi;
